import React from 'react';
import { useIntl } from 'react-intl';
export var HelpCentreTitle = function HelpCentreTitle() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var title = formatMessage({
    id: 'public-navigation.helpcentre.title'
  });
  return /*#__PURE__*/React.createElement("ul", {
    className: "tw-public-nav__list tw-public-nav__tabs",
    "data-testid": "help-centre-title"
  }, /*#__PURE__*/React.createElement("li", {
    className: "tw-public-nav__item"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/help",
    className: "tw-public-nav__item-link btn text-ellipsis btn-link btn-tab",
    title: title
  }, title)));
};